import React, { memo, useEffect, useRef, useState } from 'react';
import { useNavigateToItem } from '../atomic/links';
import { useGet } from '../../hooks/useApi';
import { formatVideoFileTime } from '../../utils/formatVideoFileTime';
import { useIntersection } from 'react-use';
import { FilesAPI } from '../../APIs/filesApi';
type ReelFileLinkProps = {
    fileId: string;
};

type ActiveLinkProps = {
    fileId: string;
};
const ActiveLink = memo(({ fileId }: ActiveLinkProps) => {
    const file = useGet(FilesAPI.item(fileId));
    const sourceId = file.data?.data?.parentFileId;
    const source = useGet(sourceId ? FilesAPI.item(sourceId) : null);
    const navigateToItem = useNavigateToItem();
    if (!file.data) {
        return <span>ID:{fileId}</span>;
    }
    return (
        <a
            href="#"
            onClick={(event) => {
                event.preventDefault();
                navigateToItem({ fileId, sourceId });
            }}
        >
            {source.data
                ? `${source.data.data.name} @ ${formatVideoFileTime(
                      file.data.data
                  )}`
                : file.data.data.name}
        </a>
    );
});
export const ReelFileLink = memo(({ fileId }: ReelFileLinkProps) => {
    const [active, setActive] = useState(false);
    const ref = useRef<HTMLAnchorElement>(null);
    const intersection = useIntersection(ref, {});
    useEffect(() => {
        if (active) return;
        if (!intersection?.isIntersecting) return;
        setActive(true);
    }, [active, intersection?.isIntersecting]);
    if (!active) {
        return <span ref={ref}>ID:{fileId}</span>;
    }
    return <ActiveLink fileId={fileId} />;
});
